export const getNextZIndex = () => {
  const zIndexElementPosition = ['absolute', 'relative', 'fixed', 'sticky'];
  let nextZIndex;
  // Selecting all elements in the dom
  const positionedElements = document.querySelectorAll('*');
  for (const element of positionedElements) {
    const computedStyle = window.getComputedStyle(element);
    const isVisible = computedStyle.visibility !== 'hidden' && computedStyle.display !== 'none';
    if ( isVisible && zIndexElementPosition.includes(computedStyle.position)) {
      const zIndex = computedStyle.zIndex;
      if (zIndex && zIndex !== 'auto') {
        if (!nextZIndex) {
          nextZIndex = Number(zIndex);
        }
        nextZIndex = Math.max(nextZIndex, Number(zIndex));
      }
    }
  }
  // If no element with zIndex is found, set it to 10000
  return nextZIndex + 1 || 10000;
};
